<div [ngSwitch]="type">
  <div class="place-holder-text semi-bold">{{ placeholder }} <div *ngIf="isRequired" class="required-field">*</div>
  </div>
  <mat-form-field *ngSwitchCase="'single'" floatLabel="never" appearance="outline">

    <mat-select #matSelect [class]="type + '-select'" [placeholder]="hintText" [formControl]="control"
      (selectionChange)="onSelectionChange($event)">
      <mat-option [class]="type + '-select-option'" *ngFor="let option of options" [value]="option.key">
        {{option.value}}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="control.touched && control.hasError('required')">{{ placeholder }} is required
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'multiple'" floatLabel="never" appearance="outline">

    <mat-select #matSelect [class]="type + '-select'" [formControl]="control" multiple
      (selectionChange)="onSelectionChange($event)">
      <mat-option [class]="type + '-select-option'" *ngFor="let option of options" [value]="option.key">
        {{option.value}}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="control.touched && control.hasError('required')">{{ placeholder }} is required
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="'search'" floatLabel="never" appearance="outline">

    <input matInput [formControl]="control" placeholder="Search here..." class="search-field" [(ngModel)]="searchValue"
      (input)="onSearchInput($event)">

    <mat-select #matSelect [class]="type + '-select'" (selectionChange)="onSelectionChange($event)">
      <mat-option [class]="type + '-select-option'" *ngFor="let option of options" [value]="option.key">
        {{option.value}}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="control.touched && control.hasError('required')">{{ placeholder }} is required
    </mat-error>
  </mat-form-field>
</div>